// extracted by mini-css-extract-plugin
module.exports = {"feature":"styles_feature__23036","last":"styles_last__2hqtG"};